module.exports = __webpack_public_path__ + "static/media/html5.99325d4e.svg";